<template>
  <div
    v-if="data"
    class="basic_wrap profile-page"
  >
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ data.name }}
      </div>
    </div>

    <section class="profile-card">
      <div class="profile-head">
        <div class="profile-title">
          <h1>{{ data.name }}</h1>
          <div class="profile-meta">
            <span>{{ $t('sky.height') }}: {{ data.height }} </span>
            <span>{{ $t('sky.high') }}: {{ data.xiong }}</span>
          </div>
        </div>
        <button
          type="button"
          class="like-button"
          :class="yizan ? 'is-liked' : ''"
          @click="dianzan"
        >
          <van-icon name="like" />
          <span>{{ data.zan }}</span>
        </button>
      </div>

      <div class="tags">
        <span
          v-for="tag in profileTags"
          :key="tag"
          class="tag"
        >
          {{ tag }}
        </span>
      </div>

      <div class="rating-row">
        <span>{{ $t('sky.fee') }}:</span>
        <van-icon
          v-for="star in 5"
          :key="star"
          name="star"
          class="star"
        />
      </div>

      <div class="address-row">
        <span>{{ $t('sky.addr') }}:</span>
        <strong>{{ data.addr }}</strong>
      </div>

      <button
        type="button"
        class="yuyueBox"
        @click="yuyue"
      >
        {{ $t('sky.yuenow') }}
      </button>
    </section>

    <section
      v-if="cur == 0"
      class="gallery-card"
    >
      <img
        v-for="(img, index) in profileImages"
        :key="img + index"
        :src="img"
        alt=""
      >
    </section>

    <section
      v-if="cur == 1"
      class="desc-card"
    >
      {{ data.desc }}
    </section>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon);

export default {
	name: "Vprofile",
	data() {
		return {
			lang: this.$i18n.locale || "zh_cn",
			data: null,
			loading: false,
			yizan: false,
			page: 1,
			list: null,
			cur: 0,
			imgs: [],
			area: null,
			arealist: null,
			locationsel: false,
			type: 0,
			finished: false,
			empty: false,
		};
	},
	computed: {
		profileTags() {
			return this.data && this.data.keys ? this.data.keys.slice(0, 4).filter(Boolean) : [];
		},
		profileImages() {
			var result = [];

			if (this.imgs && this.imgs.length) {
				for (var i = 0; i < this.imgs.length; i++) {
					result.push(this.getProfileImage(this.imgs[i]));
				}
			} else if (this.data && this.data.pic) {
				result.push(this.data.pic);
			}

			return result;
		},
	},
	created() {
		this.$parent.footer("girl", true);
	},
	mounted() {
		this.start();
	},
	methods: {
		yuyue() {
			this.$toast(this.$t("sky.jihuo"));
		},
		dianzan() {
			if (this.yizan) {
				this.data.zan = this.data.zan - 1;
				this.yizan = false;
			} else {
				this.data.zan = this.data.zan + 1;
				this.yizan = true;
			}
		},
		getProfileImage(src) {
			if (!src) {
				return "";
			}
			if (/^https?:\/\//.test(src)) {
				return src;
			}
			return "https://imgs.firstsight.help" + src;
		},
		start() {
			Fetch("/index/girl", {
				id: this.$router.history.current.params.code,
			}).then(res => {
				this.data = res.data.girl;
				this.data.keys = this.data.keystr ? this.data.keystr.split("|") : [];
				this.imgs = this.data.imgs ? this.data.imgs.split("|").filter(Boolean) : [];
			});
		},
	},
};
</script>

<style lang="less" scoped>
.profile-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 88px;
	box-sizing: border-box;
}

.page-top {
	height: 44px;
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		// filter: invert(1);
		opacity: 0.88;
	}

	.big_tit {
		max-width: 68%;
		color: #16223a;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}

.profile-card,
.gallery-card,
.desc-card {
	margin: 16px 16px 0;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.profile-card {
	padding: 18px;
}

.profile-head {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	min-width: 0;
}

.profile-title {
	min-width: 0;
	flex: 1;
}

.profile-title h1 {
	margin: 0;
	color: #ff5d7a;
	font-size: 20px;
	font-weight: 700;
	line-height: 28px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.profile-meta {
	margin-top: 8px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px 14px;
	color: #6d7688;
	font-size: 12px;
	line-height: 18px;
}

.like-button {
	width: 58px;
	min-height: 58px;
	flex: 0 0 58px;
	margin-left: 14px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border: 1px solid rgba(255, 93, 122, 0.42);
	border-radius: 50%;
	background: #fff6f8;
	color: #ff5d7a;
	font-size: 18px;
	padding: 0;
}

.like-button span {
	margin-top: 2px;
	font-size: 12px;
	line-height: 16px;
}

.like-button.is-liked {
	color: #ff6ca8;
}

.tags {
	margin-top: 14px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
}

.tag {
	max-width: 100%;
	padding: 6px 10px;
	border-radius: 8px;
	background: rgba(255, 93, 122, 0.12);
	color: #ff5d7a;
	font-size: 12px;
	line-height: 16px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.rating-row,
.address-row {
	margin-top: 14px;
	display: flex;
	align-items: center;
	color: #6d7688;
	font-size: 14px;
	line-height: 20px;
}

.rating-row span,
.address-row span {
	margin-right: 8px;
}

.star {
	color: #ffd21e;
	font-size: 15px;
	margin-right: 2px;
}

.address-row strong {
	min-width: 0;
	color: #16223a;
	font-size: 14px;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.yuyueBox {
	width: 100%;
	height: 42px;
	margin-top: 18px;
	border: 1px solid rgba(255, 93, 122, 0.42);
	border-radius: 10px;
	background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.gallery-card {
	overflow: hidden;
	background: #fff6f8;
}

.gallery-card img {
	display: block;
	width: 100%;
	max-height: 680px;
	object-fit: cover;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
}

.gallery-card img:last-child {
	border-bottom: 0;
}

.desc-card {
	padding: 18px;
	color: #6d7688;
	font-size: 14px;
	line-height: 22px;
	word-break: break-word;
}

@media screen and (max-width: 374px) {
	.profile-card,
	.gallery-card,
	.desc-card {
		margin-right: 12px;
		margin-left: 12px;
	}

	.profile-card {
		padding-right: 14px;
		padding-left: 14px;
	}

	.profile-title h1 {
		font-size: 18px;
	}
}
</style>
